import { render, staticRenderFns } from "./ReviewProposal.vue?vue&type=template&id=5ee0b986"
import script from "./ReviewProposal.vue?vue&type=script&lang=js"
export * from "./ReviewProposal.vue?vue&type=script&lang=js"
import style0 from "./ReviewProposal.vue?vue&type=style&index=0&id=5ee0b986&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports